<ng-content select="dl-form-field-label">
</ng-content>

<ng-content>
</ng-content>

<div class="dl-error-outlet">
  <ng-content select="dl-error"></ng-content>
</div>